export default async function GetAccessToken(userServiceUrl) {
    let refresh_token = localStorage.getItem('refresh_token');
    let access_token = sessionStorage.getItem('access_token');

    if (access_token !== null) {
        return access_token;
    }

    const response = await fetch(userServiceUrl + '/refresh', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${refresh_token}`
        },
    });

    if (!response.ok) {
        return null;
    }

    const data = await response.json();
    access_token = data.access_token;
    localStorage.setItem('access_token', access_token);
    return access_token;
}